import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from "@angular/material/dialog";
import { ModalContent } from "../../../interfaces/modal-content";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@tolgee/ngx";

@Component({
	selector: "app-delete-modal",
	templateUrl: "./delete-modal.component.html",
	styleUrls: ["./delete-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe],
})
export class DeleteModalComponent {
	data = inject<ModalContent>(MAT_DIALOG_DATA);
}
